import Dropzone from "react-dropzone";
import React, { useState } from "react";
import iconUpload from "../assets/icons/Upload.svg";
import iconAttachment from "../assets/icons/Attachment.svg";
import iconClose from "../assets/icons/Close.svg";
import { styleBlock } from "../styleBlock";
import { Button } from "react-bootstrap";
const Uploader = (props) => {
    const classNames = styleBlock("uploader");
    const uploaderClass = classNames.mix([props.className, props.error && "is-invalid border-danger border"]);
    const filesClass = styleBlock("selected-files").mix(props.className);
    const [files, setFiles] = useState([]);
    const [numberLimitError, setNumberLimitError] = useState();
    return (React.createElement(Dropzone, { onDrop: (newFiles) => {
            setNumberLimitError(undefined);
            const allFiles = [...files, ...newFiles];
            if (props.maxNumberOfFiles && allFiles.length > props.maxNumberOfFiles) {
                setFiles(allFiles.slice(0, props.maxNumberOfFiles));
                props.onDrop(allFiles.slice(0, props.maxNumberOfFiles));
                if (props.maxNumberOfFilesError) {
                    setNumberLimitError(props.maxNumberOfFilesError);
                }
            }
            else {
                setFiles(allFiles);
                props.onDrop(allFiles);
            }
        }, accept: props.accept, maxSize: props.maxSize, minSize: props.minSize, onDropRejected: props.onDropRejected }, ({ getRootProps, getInputProps }) => {
        var _a;
        const removeFile = (file) => {
            const newFiles = files.filter(x => x !== file);
            setFiles(newFiles);
            props.onDrop(newFiles);
        };
        return (React.createElement(React.Fragment, null,
            React.createElement("section", { className: uploaderClass },
                React.createElement("div", Object.assign({}, getRootProps(), { style: { width: "100%" } }),
                    React.createElement("input", Object.assign({ id: (_a = props.inputId) !== null && _a !== void 0 ? _a : "dropzone" }, getInputProps())),
                    React.createElement(Button, { variant: "secondary", className: "mt-4 mb-3" },
                        React.createElement("img", { width: 16, height: 16, src: iconUpload, className: "ml-n2 mr-2 my-n1", role: "presentation" }),
                        props.localization.button),
                    React.createElement("p", { className: "mb-1" }, props.localization.or),
                    React.createElement("p", { className: "mb-4 text-muted" }, props.localization.types))),
            React.createElement("section", { style: { width: "100%" }, className: filesClass }, files.map((file, index) => (React.createElement("div", { key: index, className: "file-row" },
                React.createElement("div", { className: "file-name-wrapper" },
                    React.createElement("img", { width: 18, height: 18, src: iconAttachment, className: "ml-3 mr-2", alt: "" }),
                    React.createElement("div", { className: "file-name" }, file.name)),
                React.createElement("div", { className: "ml-2 mr-3 file-remove", onClick: () => removeFile(file) },
                    React.createElement("img", { width: 16, height: 16, src: iconClose, alt: "" })))))),
            props.error && React.createElement("span", { className: "invalid-feedback" }, props.error),
            numberLimitError && React.createElement("span", { className: "invalid-feedback" }, numberLimitError)));
    }));
};
export default Uploader;
//# sourceMappingURL=index.js.map